<template>
  <Banner v-if="isStale" :key="routeKey">
    <p>{{ t('common:staleVersion.message') }}</p>
    <template #actions>
      <CButton icon="refresh" @click="reload">
        {{ t('common:staleVersion.reloadButton') }}
      </CButton>
    </template>
  </Banner>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useTranslation } from '@/composables/plugins';
import { useStaleVersionCheck } from '@/composables/useStaleVersionCheck';
import Banner from './Banner.vue';

const { t } = useTranslation();
const { isStale } = useStaleVersionCheck();
const route = useRoute();

// Re-show if after dismissing the banner the user navigates to a different top-level page (e.g. from /order/[id] to /workspace)
const routeKey = computed(() => route.path.split('/')[1]);

function reload() {
  window.location.reload();
}
</script>
